import { render, staticRenderFns } from "./inline-menu.vue?vue&type=template&id=5ff4fe67&"
import script from "./inline-menu.vue?vue&type=script&lang=js&"
export * from "./inline-menu.vue?vue&type=script&lang=js&"
import style0 from "./inline-menu.vue?vue&type=style&index=0&id=5ff4fe67&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports